import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted, onUnmounted, ref } from 'vue'
import { DevPanel } from '@sennder/shell-utilities'

import { isLocalEnv } from '@/common/config'
import { type OrcasStoreData } from '@/store'
import { getStateData } from '@/store/getters'
import { setStoreData } from '@/store/setters'
import router from '@/router'
import pkgJson from '../../package.json'
import { microfrontends } from '@/config/microfrontends'
import { shell } from '@/config/registry'
import LocalNotification from '@/components/LocalNotification.vue'
import { featureFlag } from '@/services/featureFlagProvider'


export default /*#__PURE__*/_defineComponent({
  __name: 'DevPanel',
  setup(__props) {

const featureFlags = ref<Record<string, boolean | string>>({})
const state = computed(getStateData)
const microfrontendConfigs = Object.values(microfrontends)

const onToggleOverride = async (npmName: string) => {
  // If this is the module we're currently rendering, let's reload the page to mount the new version
  if (router.currentRoute.value.meta.npmName === npmName) {
    const { fullPath } = router.currentRoute.value
    await router.push('/reload')
    await router.push(fullPath)
  }
}

const setData = (state: object) => {
  setStoreData(state as OrcasStoreData)
}

const setFeatureFlag = (key: string, value: boolean) => {
  featureFlags.value[key] = value
  featureFlag.devFunctions.overrideValue(key, value)
}

onMounted(() => {
  const unwatchFlags = featureFlag.devFunctions.watchAllFlags((flags) => {
    // @ts-expect-error IFeatureFlag supports obj
    featureFlags.value = {
      ...featureFlags.value,
      ...flags,
    }
  })

  onUnmounted(unwatchFlags)
})

return (_ctx: any,_cache: any) => {
  return (_unref(isLocalEnv)())
    ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(DevPanel), {
            "style-overrides": "",
            "module-configuration": {
        moduleConfiguration: _unref(microfrontendConfigs),
      },
            "registry-overrides": {
        shell: _unref(shell)!
      },
            "feature-flags": {
        updateFlag: setFeatureFlag,
        flags: featureFlags.value,
      },
            state: {
        state: state.value,
        updateState: setData,
      },
            overrides: {
        modules: _unref(microfrontendConfigs),
        onToggleOverride: onToggleOverride,
      },
            "log-requests": "",
            "pkg-json": _unref(pkgJson)
          }, {
            default: _withCtx(() => [
              _createVNode(LocalNotification)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["module-configuration", "registry-overrides", "feature-flags", "state", "overrides", "pkg-json"])
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}
}

})